import { Box, Heading, Image, Label, LabeledControl, Radio } from '@zillow/constellation-10';

import { LEASES_SURVEY_CONTENT, STEPS } from '../constants';

type Props = {
  onSelect: (param: Record<string, boolean | null>) => void;
  step: (typeof STEPS)[keyof typeof STEPS] & string;
  selectedOption: boolean;
};

const LeasesSurvey = ({ onSelect, selectedOption, step = STEPS.LEASES_SURVEY }: Props) => {
  return (
    <div data-testid="LeasesSurvey">
      {LEASES_SURVEY_CONTENT[step].HERO_IMAGE && (
        <Box
          data-testid="CreateLeaseHero"
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            width: '100%',
            backgroundColor: 'bg.softest',
            height: { base: '80px', md: '144px' },
          }}
        >
          <Image src={LEASES_SURVEY_CONTENT[step].HERO_IMAGE} alt={LEASES_SURVEY_CONTENT[step].HERO_IMAGE_ALT} />
        </Box>
      )}

      <Box data-testid="LeasesSurveyContentContainer" css={{ marginBlock: '400' }}>
        <Heading level={4}>{LEASES_SURVEY_CONTENT[step].HEADING}</Heading>

        {LEASES_SURVEY_CONTENT[step].BODY && (
          <Box css={{ marginTop: '400' }}>
            <Heading level={6}>{LEASES_SURVEY_CONTENT[step].BODY}</Heading>
          </Box>
        )}
      </Box>

      {LEASES_SURVEY_CONTENT[step].SURVEY_OPTIONS.map((option) => (
        <LabeledControl
          key={`LeasesSurvey-Radio-${option.label}`}
          label={<Label>{option.label}</Label>}
          control={
            <Radio
              value={String(option.value)}
              onChange={() => onSelect({ [LEASES_SURVEY_CONTENT[step].DB_VALUE]: option.value })}
              checked={selectedOption === option.value}
            />
          }
        />
      ))}
    </div>
  );
};

export default LeasesSurvey;
